import _pt from 'prop-types';
import { forwardRef, createRef, Component } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var INTERACTIONS_AFFORDANCE;

(function (INTERACTIONS_AFFORDANCE) {
  INTERACTIONS_AFFORDANCE["ESC"] = "Escape key";
  INTERACTIONS_AFFORDANCE["OVERLAY"] = "Overlay";
})(INTERACTIONS_AFFORDANCE || (INTERACTIONS_AFFORDANCE = {}));

var POSITIONS;

(function (POSITIONS) {
  POSITIONS["start"] = "start";
  POSITIONS["end"] = "end";
})(POSITIONS || (POSITIONS = {}));

var FOCUSABLE_ELEMENTS_SELECTORS = ["button", "[href]", "input", "select", "textarea", "[tabindex]:not([tabindex='-1'])"].join(", ");
var KEYS;

(function (KEYS) {
  KEYS["ESCAPE"] = "Escape";
  KEYS["TAB"] = "Tab";
})(KEYS || (KEYS = {}));

var baseClassName = "eb-drawer";
var defaultZIndex = 9000;

var DrawerNoRef = /*#__PURE__*/function (_Component) {
  _inherits(DrawerNoRef, _Component);

  var _super = _createSuper(DrawerNoRef);

  function DrawerNoRef(props) {
    var _this;

    _classCallCheck(this, DrawerNoRef);

    _this = _super.call(this, props);
    _this.drawerRef = void 0;
    _this.getBemBlocksWith = void 0;
    _this.initiallyFocusedElement = void 0;

    _this.drawerRefCallback = function (node) {
      var forwardedRef = _this.props.forwardedRef;

      if (forwardedRef) {
        if (typeof forwardedRef === "function") {
          forwardedRef(node);
        } else {
          forwardedRef.current = node;
        }
      }

      _this.drawerRef.current = node;
    };

    _this.focusOnContent = function () {
      var focusable;

      if (_this.drawerRef.current) {
        focusable = _this.drawerRef.current.querySelector(FOCUSABLE_ELEMENTS_SELECTORS);
      }

      if (focusable) {
        focusable.focus();
      }
    };

    _this.handleKeyDown = function (event) {
      if (!_this.props.isGlobal) {
        return;
      }

      var focusableElements = _this.drawerRef.current ? _this.drawerRef.current.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTORS) : [];
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
      var activeElement = document.activeElement;

      if (event.key === KEYS.ESCAPE) {
        _this.handleClose(false, INTERACTIONS_AFFORDANCE.ESC);
      } else if (event.key === KEYS.TAB && event.shiftKey) {
        if (activeElement === firstFocusable) {
          lastFocusable.focus();
          event.preventDefault();
        }
      } else if (event.key === KEYS.TAB && activeElement === lastFocusable) {
        firstFocusable.focus();
        event.preventDefault();
      }
    };

    _this.handleOpen = function () {
      var setFocusOnOpen = _this.props.setFocusOnOpen;
      document.addEventListener("keydown", _this.handleKeyDown);
      _this.initiallyFocusedElement = document.activeElement;

      if (setFocusOnOpen) {
        /* With styles we have it requires waiting two animation frames (requestAnimationFrame cycles)
        before you can focus on an element, so without timeout focus won't be set.
        When delay is less when 400 content will glitch in some cases. See US574068 for issue description.*/
        var ANIMATION_DELAY = 400;
        setTimeout(_this.focusOnContent, ANIMATION_DELAY);
      }
    };

    _this.handleClose = function (propsChanged, affordance) {
      var _this$props = _this.props,
          returnFocusSelector = _this$props.returnFocusSelector,
          setFocusOnClose = _this$props.setFocusOnClose,
          onClose = _this$props.onClose;

      if (setFocusOnClose) {
        var elementToFocus = returnFocusSelector ? document.querySelector(returnFocusSelector) : _this.initiallyFocusedElement;

        if (elementToFocus) {
          elementToFocus.focus();
        }
      }

      document.removeEventListener("keydown", _this.handleKeyDown);

      if (!propsChanged) {
        onClose(affordance);
      }
    };

    _this.handleOverlayClick = function () {
      _this.handleClose(false, INTERACTIONS_AFFORDANCE.OVERLAY);
    };

    _this.renderOverlay = function () {
      var _this$props2 = _this.props,
          disableAnimations = _this$props2.disableAnimations,
          isOpen = _this$props2.isOpen,
          isGlobal = _this$props2.isGlobal,
          showOverlay = _this$props2.showOverlay,
          _this$props2$zIndex = _this$props2.zIndex,
          zIndex = _this$props2$zIndex === void 0 ? defaultZIndex : _this$props2$zIndex;

      if (!showOverlay) {
        return null;
      }

      var overlayClassNames = cn(_this.getBemBlocksWith("__overlay"), disableAnimations && _this.getBemBlocksWith("__overlay--disable-animations"), !isGlobal && _this.getBemBlocksWith("__overlay--contained"), isOpen && _this.getBemBlocksWith("__overlay--open"));
      return /*#__PURE__*/jsx("div", {
        className: overlayClassNames,
        "data-auto": "drawer-overlay",
        onClick: _this.handleOverlayClick,
        style: {
          zIndex: zIndex
        }
      });
    };

    _this.renderDrawer = function () {
      var _this$props3 = _this.props,
          disableAnimations = _this$props3.disableAnimations,
          isOpen = _this$props3.isOpen,
          isGlobal = _this$props3.isGlobal,
          position = _this$props3.position,
          className = _this$props3.className,
          children = _this$props3.children,
          titleElementId = _this$props3.titleElementId,
          _this$props3$drawerTa = _this$props3.drawerTag,
          DrawerTag = _this$props3$drawerTa === void 0 ? "div" : _this$props3$drawerTa,
          _this$props3$zIndex = _this$props3.zIndex,
          zIndex = _this$props3$zIndex === void 0 ? defaultZIndex : _this$props3$zIndex;
      var drawerClassNames = cn(_this.getBemBlocksWith(), disableAnimations && _this.getBemBlocksWith("--disable-animations"), className, !isGlobal && _this.getBemBlocksWith("--contained"), isOpen && _this.getBemBlocksWith("--open"), position === POSITIONS.start && _this.getBemBlocksWith("--start-positioned"), position === POSITIONS.end && _this.getBemBlocksWith("--end-positioned"));
      return /*#__PURE__*/jsx(DrawerTag, {
        className: drawerClassNames,
        style: {
          zIndex: zIndex + 1
        },
        ref: _this.drawerRefCallback,
        "aria-hidden": !isOpen,
        "aria-labelledby": titleElementId,
        "data-auto": "drawer",
        tabIndex: -1,
        children: children
      });
    };

    _this.drawerRef = createRef();

    if (props.isOpen) {
      _this.handleOpen();
    }

    _this.getBemBlocksWith = createBemBlockBuilder([baseClassName, _this.props.className]);
    return _this;
  }

  _createClass(DrawerNoRef, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpening = !prevProps.isOpen && this.props.isOpen;
      var isClosing = prevProps.isOpen && !this.props.isOpen;

      if (isOpening) {
        this.handleOpen();
      }

      if (isClosing) {
        this.handleClose(true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var isGlobal = this.props.isGlobal; // It appears that document can be undefined initially in case of server-side rendering.
      // Would appreciate any suggestions for more elegant workaround

      if (typeof document === "undefined") {
        return null;
      }

      var drawer = /*#__PURE__*/jsxs(Fragment, {
        children: [this.renderOverlay(), this.renderDrawer()]
      });

      return isGlobal ? ReactDOM.createPortal(drawer, document.body) : drawer;
    }
  }]);

  return DrawerNoRef;
}(Component);

DrawerNoRef.propTypes = {
  disableAnimations: _pt.bool,
  children: _pt.node.isRequired,
  className: _pt.string,
  isGlobal: _pt.bool,
  isOpen: _pt.bool,
  position: _pt.any,
  setFocusOnOpen: _pt.bool,
  setFocusOnClose: _pt.bool,
  showOverlay: _pt.bool,
  titleElementId: _pt.string.isRequired,
  returnFocusSelector: _pt.string,
  drawerTag: _pt.any,
  zIndex: _pt.number
};
DrawerNoRef.defaultProps = {
  disableAnimations: false,
  isOpen: false,
  setFocusOnOpen: true,
  setFocusOnClose: true,
  showOverlay: true,
  isGlobal: true,
  className: "",
  position: "start",
  returnFocusSelector: ""
};
var Drawer = forwardRef(function (props, ref) {
  return /*#__PURE__*/jsx(DrawerNoRef, _objectSpread(_objectSpread({}, props), {}, {
    forwardedRef: ref
  }));
});
Drawer.displayName = "Drawer";

export { Drawer as default };
//# sourceMappingURL=drawer-esm.js.map
